import React, { useState, useEffect } from 'react';
import ComponentCard from '../../components/common/ComponentCard';
import PageBreadcrumb from '../../components/common/PageBreadCrumb';
import PageMeta from '../../components/common/PageMeta';
import Switch from '../../components/form/switch/Switch';
import { api, apiEndpoints } from '../../utils/apiService';

export default function AgentSettings() {
  const [orderAcceptAuto, setOrderAcceptAuto] = useState<boolean>(false);
  const [sendPaymentLinkAuto, setSendPaymentLinkAuto] =
    useState<boolean>(false);

  // Retrieve user ID from localStorage
  const store_user = localStorage.getItem('user_info');
  let userId: number | null = null;
  if (store_user) {
    const parsedStoreUser = JSON.parse(store_user);
    userId = parsedStoreUser.id;
  }

  // Fetch initial settings from the backend
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        if (!userId) {
          console.error('User ID not found in localStorage.');
          return;
        }

        const response = await api.get(apiEndpoints.getAgentSettings(userId));
        if (response && response.ok) {
          const data = await response.json();
          console.log(data);
          setOrderAcceptAuto(data.order_accept_auto);
          setSendPaymentLinkAuto(data.send_payment_link_auto);
        } else {
          console.error('Failed to fetch agent settings');
        }
      } catch (error) {
        console.error('Error fetching agent settings:', error);
      }
    };

    fetchSettings();
  }, [userId]);

  const handleSwitchChange = async (field: string, checked: boolean) => {
    try {
      if (!userId) {
        console.error('User ID not found in localStorage.');
        return;
      }

      // Update the state locally
      if (field === 'order_accept_auto') {
        setOrderAcceptAuto(checked);
      } else if (field === 'send_payment_link_auto') {
        setSendPaymentLinkAuto(checked);
      }

      // Make an API call to update the backend
      const response = await api.patch(
        apiEndpoints.updateAgentSettings(userId!),
        {
          order_accept_auto: orderAcceptAuto,
          send_payment_link_auto: sendPaymentLinkAuto,
        },
      );
      if (response && !response.ok) {
        console.error('Failed to update agent settings');
      }
    } catch (error) {
      console.error('Error updating agent settings:', error);
    }
  };

  return (
    <>
      <PageMeta
        title="AskArthur | Agent Settings"
        description="Agent Settings Page"
      />
      <PageBreadcrumb pageTitle="Agent Settings" />
      <div className="space-y-6">
        <ComponentCard title="Order Accept">
          <Switch
            label="Auto"
            defaultChecked={orderAcceptAuto}
            onChange={(checked) =>
              handleSwitchChange('order_accept_auto', checked)
            }
          />
        </ComponentCard>
        <ComponentCard title="Send Payment Link">
          <Switch
            label="Auto"
            defaultChecked={sendPaymentLinkAuto}
            onChange={(checked) =>
              handleSwitchChange('send_payment_link_auto', checked)
            }
          />
        </ComponentCard>
      </div>
    </>
  );
}
